module.exports = __webpack_public_path__ + "dash_20_app_assets/img/emptyfilter.e50ce424.png";